import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitPayload} from '../types/commit-types'

export function buildCommitRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('commitRoute', {
    path: '/:owner/:repo/commit/:oid',
    queries: [
      mainQuery<CommitPayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
      }),
    ],
  })
}

export const commitRoute = buildCommitRoute(commitsAppBuilder)
